import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Téléchargement Instantané', 'Aucun Abonnement', 'Accès à Vie', 'Garantie de 7 Jours'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-105" data-mp="9lbfqzxtf9d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-106" data-mp="4m8mecr76rkx">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.1rem] font-black leading-[1.04] tracking-tight text-ink sm:text-5xl md:text-[3.5rem]" data-id="element-107" data-mp="4jm4pkalevoz">
          Préparez une Année Entière de Cours de Français en seulement{' '}
          <span className="italic text-brand" data-id="element-108" data-mp="nbomx02vuk1c">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-109" data-mp="3d2ldtocrhr6i">
          Rejoignez plus de 2 000 enseignants qui ont arrêté d&apos;improviser.
          Entrez en classe avec tout le matériel prêt pour enseigner, parler et
          inspirer.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-110" data-mp="3e8msexzr8le3">
          <img src="https://cdn.magicpatterns.com/uploads/wfdm9ZdHmvJ6Q2b2htx2Yz/a8a88762-49c0-4ce2-8d4d-90c81d61114b.webp" alt="Le pack FRANÇAIS PRÊT : les six volumes de A1 à C2 avec le Master Plan, la plateforme sur ordinateur, tablette et smartphone et les 5 bonus inclus" className="mx-auto w-[70%] max-w-md sm:w-[64%]" data-id="element-111" data-mp="2qjv9kx821fdz" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-112" data-mp="s21hi9lxc9yx">
          <CtaButton href="#offer" data-id="element-113" data-mp="ibgmew5glnkr" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-114" data-mp="icrs51igt5ei">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-115" data-mp="1azkvzsr5iksq" data-mpi={index}>
                <span data-id="element-116" data-mp="161az9dps3c50">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-117" data-mp="112g6biy3k776">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}